import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import Alert from "../components/Alert";
import { cerberus, errorMessage } from "../api/cerberus";

type Status = "loading" | "ok" | "error";

export default function Verify(): JSX.Element {
  const [search] = useSearchParams();
  const token = search.get("token");
  const [status, setStatus] = useState<Status>("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Token ausente na URL.");
      return;
    }
    let cancelled = false;
    cerberus
      .verify(token)
      .then(() => {
        if (!cancelled) setStatus("ok");
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setError(errorMessage(e, "verification failed"));
        setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthLayout
      title="Verificacao de email"
      footer={<Link to="/login">Ir para login</Link>}
    >
      {status === "loading" ? <Alert variant="info">Verificando...</Alert> : null}
      {status === "ok" ? (
        <Alert variant="success">Email confirmado. Voce ja pode entrar.</Alert>
      ) : null}
      {status === "error" ? (
        <Alert variant="error">{error ?? "Token invalido ou expirado."}</Alert>
      ) : null}
    </AuthLayout>
  );
}
